export const openSidebar = () => {
    const mobileNavTrigger = document.querySelector(".mobile-nav-trigger");
    const mobileNavTriggerIcon = document.querySelector(".mobile-nav-trigger .icon");
    const mobileNavTriggerText = document.querySelector(".mobile-nav-trigger-text");
    const sidebarPanel = document.querySelector(".article-sidebar");

    mobileNavTrigger.addEventListener("click", event => {
        event.preventDefault();
        if (sidebarPanel.classList.contains("active")) {
            sidebarPanel.classList.remove("active");
            mobileNavTriggerIcon.classList.add("ion-android-menu");
            mobileNavTriggerIcon.classList.remove("ion-close");
            mobileNavTriggerText.innerText = "Open";
        } else {
            mobileNavTriggerText.innerText = "Close";
            mobileNavTriggerIcon.classList.remove("ion-android-menu");
            mobileNavTriggerIcon.classList.add("ion-close");
            sidebarPanel.classList.add("active");
        }
    });
};
